// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Container */
.sidebar-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 280px;
    height: 100vh;
    background-color: #fff;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
    padding: 16px;
    overflow-y: auto;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    z-index: 1000;
}

.sidebar-container.open {
    transform: translateX(0);
}

/* Sidebar Header */
.sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.sidebar-header .logo {
    height: 40px;
    cursor: pointer;
}

.sidebar-header .close-btn {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #888;
    cursor: pointer;
    transition: color 0.2s;
}

.sidebar-header .close-btn:hover {
    color: #555;
}

/* Menu List */
.menu-list {
    margin-top: 8px;
}

.menu-list li {
    list-style: none;
}

.menu-list a {
    display: block;
    padding: 12px;
    border-radius: 8px;
    transition: background-color 0.2s, color 0.2s;
}

.menu-list a:hover {
    background-color: #f0f4f8;
    color: black;
}

/* Dark Mode Styling */
.sidebar-container.dark {
    background-color: #2d2d2d; /* Dark mode background */
    color: white; /* Dark mode text color */
}

.menu-list a.dark:hover {
    background-color: #444; /* Dark mode hover effect */
}

/* Light Mode Styling */
.sidebar-container.light {
    background-color: #ffffff; /* Light mode background */
    color: black; /* Light mode text color */
}

.menu-list a.light:hover {
    background-color: #f1f1f1; /* Light mode hover effect */
}

/* Scrollbar Styling */
.sidebar-container {
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: green transparent;
}

.sidebar-container::-webkit-scrollbar {
    width: 8px;
}

.sidebar-container::-webkit-scrollbar-thumb {
    background-color: #4a90e2;
    border-radius: 4px;
}

.sidebar-container::-webkit-scrollbar-track {
    background: transparent;
}

.sidebar-container::-webkit-scrollbar-thumb:hover {
    background-color: #356ac6;
}

.sidebar-container::-webkit-scrollbar-thumb:active {
    background-color: #2d5293;
}

.sidebar-container::-webkit-scrollbar-track:hover {
    background: #e2e2e2;
}

/* Menu Link Active/Inactive States */
.menu-list a.active {
    background-color: #4a90e2;
    color: white;
}

.menu-list a.inactive {
    color: #b0b0b0;
}

/* Sidebar Media Queries for Responsiveness */
@media (max-width: 768px) {
    .sidebar-container {
        width: 240px;
    }

    .sidebar-header .logo {
        height: 35px;
    }
}

@media (max-width: 480px) {
    .sidebar-container {
        width: 200px;
    }

    .sidebar-header .logo {
        height: 30px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/sidebar.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA,cAAc;AACd;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,sBAAsB;AACtB;IACI,yBAAyB,EAAE,yBAAyB;IACpD,YAAY,EAAE,yBAAyB;AAC3C;;AAEA;IACI,sBAAsB,EAAE,2BAA2B;AACvD;;AAEA,uBAAuB;AACvB;IACI,yBAAyB,EAAE,0BAA0B;IACrD,YAAY,EAAE,0BAA0B;AAC5C;;AAEA;IACI,yBAAyB,EAAE,4BAA4B;AAC3D;;AAEA,sBAAsB;AACtB;IACI,qBAAqB,EAAE,YAAY;IACnC,kCAAkC;AACtC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA,6CAA6C;AAC7C;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* Sidebar Container */\r\n.sidebar-container {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 280px;\r\n    height: 100vh;\r\n    background-color: #fff;\r\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);\r\n    padding: 16px;\r\n    overflow-y: auto;\r\n    transform: translateX(-100%);\r\n    transition: transform 0.3s ease-in-out;\r\n    z-index: 1000;\r\n}\r\n\r\n.sidebar-container.open {\r\n    transform: translateX(0);\r\n}\r\n\r\n/* Sidebar Header */\r\n.sidebar-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.sidebar-header .logo {\r\n    height: 40px;\r\n    cursor: pointer;\r\n}\r\n\r\n.sidebar-header .close-btn {\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    color: #888;\r\n    cursor: pointer;\r\n    transition: color 0.2s;\r\n}\r\n\r\n.sidebar-header .close-btn:hover {\r\n    color: #555;\r\n}\r\n\r\n/* Menu List */\r\n.menu-list {\r\n    margin-top: 8px;\r\n}\r\n\r\n.menu-list li {\r\n    list-style: none;\r\n}\r\n\r\n.menu-list a {\r\n    display: block;\r\n    padding: 12px;\r\n    border-radius: 8px;\r\n    transition: background-color 0.2s, color 0.2s;\r\n}\r\n\r\n.menu-list a:hover {\r\n    background-color: #f0f4f8;\r\n    color: black;\r\n}\r\n\r\n/* Dark Mode Styling */\r\n.sidebar-container.dark {\r\n    background-color: #2d2d2d; /* Dark mode background */\r\n    color: white; /* Dark mode text color */\r\n}\r\n\r\n.menu-list a.dark:hover {\r\n    background-color: #444; /* Dark mode hover effect */\r\n}\r\n\r\n/* Light Mode Styling */\r\n.sidebar-container.light {\r\n    background-color: #ffffff; /* Light mode background */\r\n    color: black; /* Light mode text color */\r\n}\r\n\r\n.menu-list a.light:hover {\r\n    background-color: #f1f1f1; /* Light mode hover effect */\r\n}\r\n\r\n/* Scrollbar Styling */\r\n.sidebar-container {\r\n    scrollbar-width: thin; /* Firefox */\r\n    scrollbar-color: green transparent;\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar {\r\n    width: 8px;\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar-thumb {\r\n    background-color: #4a90e2;\r\n    border-radius: 4px;\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar-track {\r\n    background: transparent;\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar-thumb:hover {\r\n    background-color: #356ac6;\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar-thumb:active {\r\n    background-color: #2d5293;\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar-track:hover {\r\n    background: #e2e2e2;\r\n}\r\n\r\n/* Menu Link Active/Inactive States */\r\n.menu-list a.active {\r\n    background-color: #4a90e2;\r\n    color: white;\r\n}\r\n\r\n.menu-list a.inactive {\r\n    color: #b0b0b0;\r\n}\r\n\r\n/* Sidebar Media Queries for Responsiveness */\r\n@media (max-width: 768px) {\r\n    .sidebar-container {\r\n        width: 240px;\r\n    }\r\n\r\n    .sidebar-header .logo {\r\n        height: 35px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .sidebar-container {\r\n        width: 200px;\r\n    }\r\n\r\n    .sidebar-header .logo {\r\n        height: 30px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
